import http from './http.js';


// get请求
export function getListAPI(params){
    return http.get(`/Api/getList`,params)
}
export function oneKeyMakeTask(farm_id){
    return http.get(`/data/task/make_work_task/`+farm_id)
}
//获取会员信息接口
export function getUserInfo(){
    return http.get(`/user/user/get_user_info`)
}
export function getFarmUserPri(farm_id){
    return http.get(`/user/farm/get_farm_user_pri/`+farm_id)
}
export function checkFarm(){
    return http.get(`/user/farm/check_farm`)
}

//获取会员信息接口
export function updateUser(params){
    return http.post(`/user/user/update_user`,params)
}
//发送验证码
export function sendsms(params){
    return http.post(`/sms/sendsms`,params)
}
//注册会员
export function register(params){
    return http.post(`/user/register`,params)
}
//用户验证码登录
export function login(params){
    return http.post(`/user/login`,params)
}
//用户账户登录
export function account_login(params){
    return http.post(`/user/account_login`,params)
}
//用户修改密码
export function modifyPassword(params){
    return http.post(`/user/user/modify_password`,params)
}
//用户修改密码
export function modifyMobile(params){
    return http.post(`/user/user/modify_mobile`,params)
}


//提交用户个人实名认证信息
export function personVerify(params){
    return http.post(`/user/user/person_verify`,params)
}

//获取用户个人实名认证信息
export function getUserVerify(){
    return http.get(`/user/user/get_user_verify`)
}

//提交用户企业实名认证信息
export function personCompanyVerify(params){
    return http.post(`/user/user/person_company_verify`,params)
}
//获取用户个人实名认证信息
export function getUserCompanyVerify(){
    return http.get(`/user/user/get_user_company_verify`)
}

export function get_user_company(){
    return http.get(`/user/farm/get_user_company`)
}
export function personCompanySet(params){
    return http.post(`/user/farm/person_company_set`,params)
}

//建立园区页面或者省份列表和农作物
export function get_province_crop(){
    return http.get(`/region/get_province_crop`)
}

//根据父级id取下级地区列表
export function get_region_list(parent_id){
    return http.get(`/region/get_region_list/`+parent_id)
}
export function getRuleClause(parent_id){
    return http.get(`/rule/get_rule_clause`)
}

export function judgeFarmUser(farm_id){
    return http.get(`/user/farm/judge_farm_user/`+farm_id)
}

//暂存园区第一步

export function createFarm(params){
    return http.post(`/user/farm/create_farm`,params)
}

//建立正式园区
export function saveFarm(params){
    return http.post(`/user/farm/save_farm`,params)
}

//完善园区信息
export function updateFarm(params){
    return http.post(`/user/farm/update_farm`,params)
}
export function updateCheckedFarm(farm_id,params){
    return http.post(`/user/farm/update_checked_farm/`+farm_id,params)
}
//提交园区管理人员
export function createFarmUser(farm_id,params){
	return http.post(`/user/farm/create_farm_user/`+farm_id,params)
}
//更新园区信息

export function saveFarmDetail(farm_id,params){
	return http.post(`/user/farm/save_farm_detail/`+farm_id,params)
}


//时间筛选，获取年份相关信息 1，农事信息，2作物，3分区
export function getFarmThisYear(farm_id,year,type){
    return http.get(`/user/farm/get_farm_detail/`+farm_id+'/'+year+'/'+type)
}

//创建第二年相关信息
export function createFarmSecondYear(farm_id,type,year){
	return http.post(`/user/farm/create_second_year/`+farm_id+"/"+type+"/"+year)
}
//修改园区信息，按作物大类删选
export function changeTableCrop(farm_id,dict_id){
	return http.get(`/user/farm/change_table_crop/`+farm_id+"/"+dict_id)
}
//设置园区作物
export function saveFarmCrop(farm_id,params){
	return http.post(`/user/farm/save_farm_crop/`+farm_id,params)
}
//设置园区分区
export function saveFarmPartition(farm_id,params){
	return http.post(`/user/farm/save_farm_partition/`+farm_id,params)
}
//更新分区字段，比如冠幅，平均售价，上一季产品，生命周期
export function saveFarmAreaField(params){
	return http.post(`/user/farm/save_farm_area_field`,params)
}

//保存分区物候期
export function saveFarmAreaEnophase(params){
	return http.post(`/user/farm/save_farm_area_enophase`,params)
}
//改变分区状态
export function changeAreaStatus(area_id,status){
	return http.post(`/user/farm/change_area_status/`+area_id+"/"+status)
}
//获取相同作物分区列表
export function getFarmSameCrop(area_id){
	return http.get(`/user/farm/get_farm_same_crop/`+area_id)
}
export function changeMaterialCategory(cate_id){
	return http.get(`/user/farm/get_ingred_list/`+cate_id)
}
export function changeMaterialsCategory(cate_id){
	return http.get(`/data/materials/get_materials_list/`+cate_id)
}
export function stocklock(id,is_lock){
	return http.post(`/user/farm/materials_lock/`+id+'/'+is_lock)
}

//根据作物大类选择病虫害
export function getDataPest(dict_id){
	return http.get(`/data/pest/get_data_pest/`+dict_id)
}
export function saveFarmInsectPest(farm_id,params){
	return http.post(`/user/farm/save_farm_insect_pest/`+farm_id,params)
}
//复制分区
export function copyFarmPartition(params){
	return http.post(`/user/farm/copy_farm_partition`,params)
}

export function saveFarmRemark(farm_id,params){
	return http.post(`/user/farm/save_farm_remark/`+farm_id,params)
}

//园区设备管理 
export function saveFarmDevice(farm_id,params){
	return http.post(`/user/farm/save_farm_device/`+farm_id,params)
}
//获取园区设备管理
export function getFarmDevice(farm_id,data){
	return http.get(`/user/farm/get_farm_device/`+farm_id,data)
}
//删除操作
export function deleteFarmOther(id,controller,action){
	return http.delete(`/user/`+controller+`/`+action+`/`+id)
}

export function deleteDrugMaterial(id){
	return http.delete(`/user/farm/delete_drug_task_material/`+id)
}

export function setFarmWorkDrugMaterialRate(id,params){
	   return http.post(`/user/farm/set_drug_material_rate/`+id,params)
}
//获取唯一一个待提交的提交信息
export function get_farm_nocheck_info(){
	   return http.get(`/user/farm/get_farm_nocheck_info`)
}
export function getFarmUser(farm_id,params){
	   return http.post(`/user/farm/get_farm_user/`+farm_id,params)
}
//设置或者取消负责人
export function setPrincipal(id,type){
	   return http.post(`/user/farm/set_principal/`+id+'/'+type)
}

//获取唯一一个待提交的提交信息
export function getFarmInfo(id){
	   return http.get(`/user/farm/get_farm_info/`+id)
}
export function getFarmAreaList(farm_id,year){
	   return http.get(`/user/farm/get_farm_area_list/`+farm_id+'/'+year)
}
export function getHomeFarmInfo(id){
	   return http.get(`/user/farm/get_home_farm_info/`+id)
}
//获取唯一一个待提交的提交信息
export function get_data_crop(dict_id){
	   return http.get(`/data/crop/get_data_crop/`+dict_id)
}

//保存园区作物
export function create_fram_crop(params){
    return http.post(`/user/farm/create_fram_crop`,params)
}
//删除园区作物
export function delete_farm_crop(id){
    return http.delete(`/user/farm_crop/delete_farm_crop/`+id)
}

//获取唯一一个待提交的提交信息
export function getFarmList(type){
	   return http.get(`/user/farm/get_farm_list/`+type)
}

//库存管理
export function getFarmMaterials(farm_id,param){
	   return http.get(`/user/farm/get_farm_materials/`+farm_id,param)
}

export function changeSoil(material_id){
	   return http.post(`/user/farm/get_soil_unit/`+material_id)
}


export function addFarmDrugMaterial(work_task_id,param){
	   return http.post(`/user/farm/add_farm_drug_material/`+work_task_id,param)
}
//保存化肥
export function saveFarmSoil(farm_id,param){
	   return http.post(`/user/farm/save_farm_soil/`+farm_id,param)
}
//修改化肥
export function editFarmSoil(farm_id,param){
	   return http.post(`/user/farm/edit_farm_soil/`+farm_id,param)
}
//保存农资包括新增和更新
export function saveFarmMaterials(farm_id,param){
	   return http.post(`/user/farm/save_farm_materials/`+farm_id,param)
}
//根据农资类型获取说是有库存
export function getMaterialList(farm_id,type){
	   return http.get(`/user/farm/get_material_list/`+farm_id+'/'+type)
}

//新增库存
export function addMaterialStock(farm_id,param){
	   return http.post(`/user/farm/add_materials_stock/`+farm_id,param)
}

//减持库存
export function reduceMaterialStock(farm_id,param){
	   return http.post(`/user/farm/reduce_materials_stock/`+farm_id,param)
}

//获取物资出入库记录


export function getFarmStockRecord(farm_id,material_id,year,type){
	   return http.get(`/user/farm/get_farm_stock_record/`+farm_id+'/'+material_id+'/'+year+'/'+type)
}
//确认出入库记录
export function stockRecordConfirm(id){
	   return http.post(`/user/farm/farm_stock_record_confirm/`+id)
}
//删除出入库记录
export function stockRecordDelete(id){
	   return http.delete(`/user/farm/farm_stock_record_delete/`+id)
}

//批量生成年计划changeYear
export function makeFarmYearPlan(id,partition_id,year,type){
	   return http.post(`/data/task/make_year_plan/`+id+'/'+partition_id+'/'+year+"/"+type)
}
//获取年计划相关信息

export function getFarmYearTask(farm_id,area_id,year,param){
	   return http.post(`/user/task/get_farm_year_task/`+farm_id+'/'+area_id+'/'+year,param)
}
//清空年计划
export function clearFarmYearTask(farm_id,area_id,year){
	   return http.post(`/user/task/clear_farm_year_task/`+farm_id+'/'+area_id+'/'+year)
}

//新增年计划任务
export function getAllTask(param){
	    return http.get(`/data/task/get_all_task`,param)
}
//新增年计划任务
export function addFarmYearTask(farm_id,partition_id,year,param){
	    return http.post(`/user/task/add_farm_year_task/`+farm_id+'/'+partition_id+'/'+year,param)
}
//删除年计划
export function deleteFarmTask(action,id){
	    return http.delete(`/user/farm/`+action+'/'+id)
}
//获取单个年计划任务的详情
export function getYearTaskInfo(task_id){
	    return http.get(`/user/task/get_year_task/`+task_id)
}

//修改任务的字段
export function changeYearTaskByfield(task_id,param){
	    return http.post(`/user/task/change_year_task_field/`+task_id,param)
}

//获取园区分区预算
export function getFarmAreaBudget(farm_id,partition_id,year){
	    return http.get(`/user/farm/get_farm_area_budget/`+farm_id+'/'+partition_id+'/'+year)
}

//提交分区预算
export function submitFarmAreaBudget(farm_id,partition_id,year,param){
	    return http.post(`/user/farm/submit_farm_area_budget/`+farm_id+'/'+partition_id+'/'+year,param)
}

//批量发布
export function publishFarmYearWork(farm_id,area_id,year){
	    return http.post(`/user/farm/publish_farm_year_work/`+farm_id+'/'+area_id+'/'+year)
}
//获取工作任务相关列表
export function getFarmWorkTask(farm_id,year,type,is_source,param){
	   return http.post(`/user/task/get_farm_work_task/`+farm_id+'/'+year+'/'+type+'/'+is_source,param)
}

//新增工作任务
export function getAllWorkTask(type_id){
	    return http.get(`/data/task/get_all_work_task/`+type_id)
}

//新增工作任务
export function addFarmWorkTask(farm_id,year,param){
	    return http.post(`/user/task/add_farm_work_task/`+farm_id+'/'+year,param)
}
export function checkFarmWorkTask(farm_id,param){
	    return http.post(`/user/task/check_farm_work_task/`+farm_id,param)
}


//批量操作type为1为批量发布，为2位批量删除
export function batchOperate(type,param){
	    return http.post(`/user/task/batch_operate/`+type,param)
}
//批量安排任务
export function batchPlanTask(param){
	    return http.post(`/user/task/batch_plant_task`,param)
}

//获取单个工作任务的详情
export function getWorkTaskInfo(task_id){
	    return http.get(`/user/task/get_work_task/`+task_id)
}

//修改工作任务的字段
export function changeWorkTaskByfield(task_id,param){
	    return http.post(`/user/task/change_work_task_field/`+task_id,param)
}

export function getDictList(pid){
	    return http.get(`/dict/get_all_list/`+pid)
}
export function getDiagnoseList(dict_id){
	    return http.get(`/data/diagnose/get_all_diagnose/`+dict_id)
}
export function saveFarmWorkTaskDiagnose(work_task_id,param){
	    return http.post(`/user/task/save_farm_work_task_diagnose/`+work_task_id,param)
}

export function getFarmYearTaskYears(farm_id,area_id){
	   return http.get(`/user/farm/get_farm_year_task_year/`+farm_id+'/'+area_id)
	   }

export function getFarmWorkTaskYears(farm_id,area_id,year){
	    return http.get(`/user/farm/get_farm_work_task_year/`+farm_id+'/'+area_id)
}

export function copyFarmYearTask(farm_id,partition_id,year,param){
	   return http.post(`/user/farm/copy_farm_year_task/`+farm_id+'/'+partition_id+'/'+year,param)
}
export function copyFarmWorkTask(farm_id,partition_id,year,param){
	   return http.post(`/user/farm/copy_farm_work_task/`+farm_id+'/'+partition_id+'/'+year,param)
}